import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import {
  getFocusRing,
  getSurfaceBorder,
  getSurfaceColor,
  getThemeTokens,
  radii,
} from '../tokens';

export const styledMuiOutlinedInput = (
  theme: Theme,
): BackstageOverrides['MuiOutlinedInput'] => {
  const tokens = getThemeTokens(theme);

  return {
    root: {
      backgroundColor: getSurfaceColor(theme, 'raised'),
      borderRadius: radii.md,
      transition:
        'border-color 150ms ease, box-shadow 150ms ease, background-color 150ms ease',
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: getSurfaceBorder(theme),
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: getSurfaceBorder(theme, 'strong'),
      },
      '&.Mui-focused': {
        boxShadow: getFocusRing(theme),
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 1,
      },
      '&.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.error.main,
      },
      '&.Mui-disabled': {
        backgroundColor: getSurfaceColor(theme, 'subtle'),
      },
    },
    input: {
      color: tokens.textPrimary,
      padding: theme.spacing(1.125, 1.5),
    },
  };
};
